
        <label class="checkbox" [class.selected]="selected">
            <span class="checkbox__icon">
                <input type="checkbox" [(ngModel)]="selected">
            </span>
            <ng-content></ng-content>
        </label>
    